import { FC } from 'react'
import { ErrorOutline, SaveAlt } from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'

interface SaveDraftDialogProps {
  open: boolean
  errorMessage: string
  onSaveDraft: () => void
  onClose: () => void
}

export const SaveDraftDialog: FC<SaveDraftDialogProps> = ({ open, errorMessage, onSaveDraft, onClose }) => {
  const handleSaveDraft = () => {
    onSaveDraft()
    onClose()
  }

  return (
    <Dialog open={open} maxWidth='sm' fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <ErrorOutline color='error' />
        Ошибка сохранения на сервере
      </DialogTitle>

      <DialogContent>
        <Typography
          variant='body2'
          sx={{ p: 1.5, mb: 2, bgcolor: 'error.light', color: 'error.contrastText', borderRadius: 1 }}
        >
          {errorMessage}
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          Изменения не были сохранены на сервере. Вы можете сохранить черновик локально в браузере и
          повторить попытку позже.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color='inherit'>
          Закрыть
        </Button>
        <Button onClick={handleSaveDraft} variant='contained' color='warning' startIcon={<SaveAlt />}>
          Сохранить в черновик
        </Button>
      </DialogActions>
    </Dialog>
  )
}
